import React from 'react';

import { AlertTitle, Box, Paper, Typography } from '@mui/material';

type MfaSetupNoteProps = {
  isImmediateVerification?: boolean;
  isAuthStep?: boolean;
  isAuthRoute?: boolean;
  isMfaRequired?: boolean;
};

export const MfaSetupNote: React.FC<MfaSetupNoteProps> = ({
  isImmediateVerification,
  isAuthStep,
  isAuthRoute,
  isMfaRequired,
}) => {
  const renderText = () => {
    return (
      <Typography variant="body1" sx={paragraphStyles}>
        For added security,{' '}
        {isMfaRequired ? 'you need to enable' : 'we strongly recommend enabling'} Multi-Factor
        Authentication (MFA) on your account. Follow these simple steps to set it up:
      </Typography>
    );
  };

  const renderList = () => {
    const authStepText = isAuthStep ? ' on the next step.' : '.';

    return (
      <ol style={listStyles}>
        {!isImmediateVerification && (
          <Typography variant="body1" mb={1} mt={1} component="li">
            Input your password: Once you input your password and click submit, you will then see a
            QR Code on your screen.
          </Typography>
        )}
        <Typography variant="body1" mb={1} component="li">
          Download an authentication app: We recommend using Google Authenticator or a similar app,
          such as Authy or Microsoft Authenticator{authStepText}
        </Typography>
        <Typography variant="body1" mb={1} component="li">
          Scan the QR code: After installing the authentication app, open it and use your
          device&apos;s camera to scan the QR code displayed on the MFA setup screen. This will link
          your account to the app{authStepText} Alternatively, you can use the setup key if you are
          not able to scan the QR code.
        </Typography>
        <Typography variant="body1" mb={1} component="li">
          Enter the verification code: The authentication app will generate a unique, temporary
          verification code. Enter this code into the designated input field on the MFA setup screen
          {authStepText}
        </Typography>
        <Typography variant="body1" component="li">
          Submit your information: Click the &quot;Submit&quot; button to complete the MFA setup
          process. Once successfully set up, you&apos;ll be prompted to enter a verification code
          from the authentication app each time you log in to your account. This ensures an extra
          layer of security for your information
          {authStepText}
        </Typography>
      </ol>
    );
  };

  if (isAuthRoute) {
    return (
      <Box>
        {renderText()}
        {renderList()}
      </Box>
    );
  }

  return (
    <Paper variant="outlined" sx={paperStyles}>
      <AlertTitle>Setting Up Multi-Factor Authentication</AlertTitle>

      {renderText()}
      {renderList()}
    </Paper>
  );
};

const paragraphStyles: React.CSSProperties = {
  marginBottom: 0,
};

const paperStyles: React.CSSProperties = {
  padding: '20px',
  borderWidth: '1px',
  borderColor: '#454747',
};

const listStyles: React.CSSProperties = {
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: '1.3em',
};
